import { useState } from 'react';
import { G } from '@mobily/ts-belt';
import { Banner, Button } from '@stitch-fix/mode-react';
import { SearchFragment } from '../../utils/hooks/getSearchResults';
interface SiteNavigationBannerProps {
  search: SearchFragment;
}

/**
 * The `<SiteNavigationBanner />` component displays content from the
 * SiteNavigationModule to quickly direct a client to support pages
 * based on their query to 'cancel', 'order', 'help', and many others.
 */
const SiteNavigationBanner = ({
  search: {
    siteNavigationModule
  }
}: SiteNavigationBannerProps) => {
  const [isOpen, setIsOpen] = useState(true);
  return <>
      {G.isObject(siteNavigationModule) && isOpen && <Banner variant="info-border" headline={siteNavigationModule.title} mb={2} primaryLink={<Button as="a" variant="outline" href={siteNavigationModule.cta.destinationPath} width="fit">
              {siteNavigationModule.cta.text}
            </Button>} secondaryLink={<Button variant="text" onClick={() => {
      setIsOpen(false);
    }}>
              Dismiss
            </Button>} onClose={() => {
      setIsOpen(false);
    }}>
          {siteNavigationModule.description}
        </Banner>}
    </>;
};
export default SiteNavigationBanner;